import { Outlet } from 'react-router-dom';
import ClientUsersList from './portalClients/ClientUsersList';
import ClientTaskSection from './portalTasks/ClientTaskSection';
import { ControlledShow } from 'framework/show';
import { useClientPortalProjectDataContext } from '../context/ClientPortalContext';

const ProjectClientPortalLayout = () => {
  const {
    clientPortalData: projectClientPortalData,
    users,
    isActiveRequestsLoading,
    isClientPortalDataReloading,
  } = useClientPortalProjectDataContext();

  return (
    <ControlledShow data={projectClientPortalData}>
      <ClientUsersList
        clientPortalData={projectClientPortalData}
        isActiveRequestsLoading={isActiveRequestsLoading || isClientPortalDataReloading}
      />
      {!!projectClientPortalData.clients?.length && (
        <ClientTaskSection projectData={projectClientPortalData} portalUsers={users} />
      )}
      <Outlet />
    </ControlledShow>
  );
};
export default ProjectClientPortalLayout;
